<template>
  <v-navigation-drawer id="appDrawer" :mini-variant.sync="mini" fixed :dark="$vuetify.dark" app v-model="drawer"
    width="260">
    <v-toolbar color="teal darken-1" dark>
      <!-- Titulo superior (SIGAS azul) -->
      <v-toolbar-title class="ml-0 pl-3"></v-toolbar-title>
      <span class="hidden-sm-and-down logo">SIGAS</span>
    </v-toolbar>
    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
      <v-list dense expand>
        <template v-for="(item, i) in menus">
          <!-- group with subitems -->
          <v-list-group v-if="item.items" :key="'group-' + i" :prepend-icon="item.icon">
            <v-list-tile slot="activator" ripple>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(subItem, j) in item.items">
              <!-- sub group -->
              <v-list-group v-if="subItem.items" :key="'sub-group-' + j">
                <v-list-tile slot="activator" ripple>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-for="(grand, k) in subItem.children" :key="'grand-' + k"
                  :to="genChildTarget(item, grand)" :href="grand.href" ripple>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <!-- child item -->
              <v-list-tile v-else :key="'child-' + j" :to="genChildTarget(item, subItem)" :href="subItem.href">
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="subItem.action">
                  <v-icon :class="[subItem.actionClass || 'success--text']">{{
                    subItem.action
                    }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list-group>
          <!-- subheader -->
          <v-subheader v-else-if="item.header" :key="'header-' + i">
            {{ item.header }}
          </v-subheader>
          <!-- divider -->
          <v-divider v-else-if="item.divider" :key="'divider-' + i"></v-divider>
          <!-- items menu con enlace (entradas "normales") -->
          <v-list-tile v-else :key="'item-' + i" :to="!item.href ? { name: item.name } : null" :href="item.href" ripple
            :disabled="item.disabled">
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="item.subAction">
              <v-icon class="success--text">{{ item.subAction }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
import menu from "@/api/menu";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "axios";
import jwtDecode from "jwt-decode";
export default {
  name: "app-drawer",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    mini: false,
    drawer: true,
    menus: menu,
    scrollSettings: {
      maxScrollbarLength: 160,
    },
    user: "",
  }),
  computed: {
    computeGroupActive() {
      return true;
    },
    computeLogo() {
      return "/static/logo.png";
    },
    sideToolbarColor() {
      return this.$vuetify.options.extra.sideNav;
    },
  },
  created() {
    let token = localStorage.getItem("token");
    const decodedToken = jwtDecode(token);
    const userDto = decodedToken.dto;
    this.user = {
      id: userDto.id,
      nombre: userDto.nombre,
      apellido: userDto.apellido,
      tipo: userDto.tipo,
    };
    // console.log("tipo:" + this.user.tipo + "::" + JSON.stringify(this.user, null, 2));
    if (this.user.tipo != "ADMINISTRADOR") {
      let menuRes = this.menus.filter(
        (m) =>
          m.title != "Auditoria" &&
          m.title != "Contratos" &&
          m.title != "Log de Aplicacion" &&
          m.title != "Gestion de Usuarios"
      );
      // console.log("ADMINISTRADOR:sale:" + JSON.stringify(this.menus, null, 2));
      this.menus = menuRes;
    }
    if (this.user.tipo == "AGENCIA") {
      let menuRes = this.menus.filter(
        (m) => m.title != "Registro Civil" && m.title != "Log de Aplicacion"
      );
      // console.log("AGENCIA:sale:" + JSON.stringify(this.menus, null, 2));
      this.menus = menuRes;
    }
    if (this.user.tipo == "PROVEEDOR") {
      let menuRes = this.menus.filter(
        (m) =>
          m.title != "Descargas Consolidadas" &&
          m.title != "Registro Civil" &&
          m.title != "Reporteria" &&
          m.title != "Empadronamiento" &&
          m.title != "Panel de Contratos"
          &&
          m.title != "Ingreso de multas"
      );
      // console.log("PROVEEDOR:sale:" + JSON.stringify(this.menus, null, 2));
      this.menus = menuRes;
    }
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.drawer = !this.drawer;
    });
  },
  // destroyed() {
  //   window.getApp.$emit("APP_ON_CLOSE");
  // },

  methods: {
    genChildTarget(item, subItem) {
      return 1 / 0;
      // console.log("item:" + JSON.stringify(item, null, 2));
      if (subItem.href) return;
      if (subItem.component) {
        // console.log("component:" + subItem.component + "::" + JSON.stringify(subItem, null, 2));
        return {
          name: subItem.component,
        };
      }
      // console.log("name:" + subItem.name + "::" + JSON.stringify(subItem, null, 2));
      return { name: `${item.group}/${subItem.name}` };
    },
    async loadInfoUser() {
      try {
        let userId = localStorage.getItem("userId");
        let token = localStorage.getItem("token");
        console.log("loadInfoUser::" + token + "::" + JSON.stringify(userId, null, 2));

        const response = await axios.get("/user/" + userId, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        let user = response.data;
        let resp = {
          token: token,
          user: user,
        };
        this.user = user;
        // console.log("loadInfoUser::" + JSON.stringify(resp, null, 2));
        this.$store.commit("auth_success", resp);

        setTimeout(() => {
          this.$router.push({ name: "ProveedorImpresion" }).catch(() => { });
        }, 1000);
      } catch (error) {
        console.log("Error al cargar usuario:", error);
      }
    }
    ,
  },
};
</script>

<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';

#appDrawer
  overflow: hidden
  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto
</style>
